import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

// Relative, not via '@shared/components': that barrel re-exports this component's own folder, and
// the resulting cycle leaves AppVersionComponent undefined when the decorator runs.
import { AppVersionComponent } from '../app-version/app-version.component';

interface NavigationMenuItem {
  href: string;
  icon: string;
  title: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, RouterLinkActive, RktIconComponent, AppVersionComponent],
})
export class SidebarComponent {
  menuItems: NavigationMenuItem[] = [
    { href: '/app/business-accounts', icon: 'briefcase', title: 'Business Accounts' },
    { href: '/app/financial-accounts', icon: 'bank', title: 'Financial Accounts' },
    { href: '/app/transactions', icon: 'bank', title: 'Transaction Activity' },
    { href: '/app/exception-management', icon: 'exceptions-list', title: 'Exceptions' },
    { href: '/app/consents', icon: 'document', title: 'Consents' },
    { href: '/app/terminal', icon: 'dashboard', title: 'Terminal' },
  ];
}
